import React from "react";
import { Typography, Card, CardContent } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import { IMatch } from "apis";
import { parseTimestampIntoLocalDateTime } from "utils";
import { routing } from "routing";

const { Urls } = routing;

const useStyles = makeStyles(() => ({
  card: {
    // must add pointerEvents otherwise click does not work, ref to https://github.com/recharts/recharts/issues/1883
    pointerEvents: "all",
    cursor: "pointer",
  },
}));

export const MatchTooltip = ({ active, payload }: any) => {
  const classes = useStyles();
  const history = useHistory();

  if (!active || !payload) {
    return null;
  }

  const match: IMatch = payload[0].payload.raw;
  const homeTeamName = match.homeFullTeam?.name || "-";
  const awayTeamName = match.awayFullTeam?.name || "-";

  const handleClick = () => {
    history.push(Urls.MATCH_STATS(match.id));
  };

  return (
    <Card className={classes.card} onClick={handleClick}>
      <CardContent>
        <Typography variant="h4">
          {`${homeTeamName} vs ${awayTeamName}`}
        </Typography>
        <p>
          {`${match.homeScore < 0 ? "-" : match.homeScore} : ${
            match.awayScore < 0 ? "-" : match.awayScore
          }`}{" "}
        </p>
        <p>{parseTimestampIntoLocalDateTime(match.startTime)}</p>
        <p>{match.description}</p>
      </CardContent>
    </Card>
  );
};
